import { types } from "mobx-state-tree";
import { createContext, useContext } from "react";

import {
  createMarketPlaceStore,
  MarketPlaceStore,
} from "stores/marketPlaceStore";
import { createUserStore, UserStore } from "stores/userStore";
import { createPageStore, PageStore } from "stores/pageStore";

const RootStore = types.model("RootStore", {
  userStore: UserStore,
  marketPlaceStore: MarketPlaceStore,
  pageStore: PageStore,
});

export const createRootStore = () => {
  const userStore = createUserStore();
  const marketPlaceStore = createMarketPlaceStore();
  const pageStore = createPageStore();
  return RootStore.create({ userStore, marketPlaceStore, pageStore });
};

type TRootStore = ReturnType<typeof createRootStore>;
const RootStoreContext = createContext<TRootStore>({} as TRootStore);

export const RootStoreProvider = RootStoreContext.Provider;
export const useStores = () => useContext(RootStoreContext);
